// Etykieta ceny kursu (np. "/rok") jest wolnym tekstem z panelu admina.
// Tu mapujemy znane skrócone etykiety na pełny, czytelny opis dostępu.
export function formatPriceLabel(label: string | null | undefined): string {
  const normalized = (label || "").trim().toLowerCase();
  if (normalized === "/rok" || normalized === "rok") return "dostęp na cały rok";
  return label || "";
}
